export default "__VITE_ASSET__4e296a7f__"